<template>
  <Modal
      v-model="_value"
      width="650"
      title="导出安装证明"
      @on-visible-change="visibleChange"
      ok-text="关闭"
      cancel-text="">
    <div style="position:relative;">
      <Table border highlight-row size="small" height="200" :columns="columns" :stripe="true" :data="content" ref="table"
             @on-sort-change="sortChange"></Table>
      <div style="position:absolute;top:0px;width:100%;height:100%;display: flex;
                            align-items: center;
                            justify-content: center;background: rgba(210, 216, 222, 0.5);" v-if="listLoadding">
        <Spin size="large"></Spin>
        <h6 style="color:#2d8cf0;margin-top:10px;">正在获取数据...</h6>
      </div>
    </div>
    <Modal v-model="setDatetimeModal" title="时间" @on-ok="onOk" ok-text="导出">
      <Form autoComplete="on" class="card-box login-form">
        <Form-item label="地区">
          <Select style="width: 60px;" v-model="certificateArea">
            <Option v-for="item in certificateAreaOptions" :value="item.value" :key="item.value">{{item.label}}</Option>
          </Select>
        </Form-item>
        <Form-item label="安装日期">
          <DatePicker type="date" placeholder="安装日期" style="width: 200px;margin-right: 10px;"
                      v-model="installDatetime"></DatePicker>
        </Form-item>
        <Form-item label="打印日期">
          <DatePicker type="date" placeholder="打印日期" style="width: 200px;margin-right: 10px;"
                      v-model="exportDatetime"></DatePicker>
        </Form-item>
      </Form>
    </Modal>
  </Modal>
</template>
<script>

import Vue from 'vue'
import { mapActions } from 'vuex'
import store from '@/store'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'

export default {
  name: 'exportvehiclecertmodal',
  components: {},
  props: {
    value: {
      type: Boolean,
      default: false
    },
    initValue: null,
    installed: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {

      certificateAreaOptions: [
        { label: '中山', value: 1 },
        { label: '江门', value: 2 }
      ],

      // 设置时间
      setDatetimeId: null,
      setDatetimeModal: false,
      installDatetime: null,
      exportDatetime: null,
      certificateArea: 1,

      modify: false,
      positioningDeviceInfoDetailModal: false,
      positioningDeviceInfoDetailId: null,
      searchPositioningDeviceInfoList: [],
      searchPositioningDeviceInfoLoading: false,
      selectPositioningDeviceInfos: [],
      positioningDeviceInfoStateOptions: [
        { label: '未安装', value: 1 },
        { label: '已安装', value: 2 },
        { label: '损坏', value: 3 }
      ],
      positioningDeviceModelOptions: [
        { label: 'BSJ-A6-BD', value: 1 },
        { label: 'BSJ-GF03', value: 2 },
        { label: 'BSJ-M11', value: 3 },
        { label: 'K5', value: 4 },
        { label: 'D5X', value: 5 },
        { label: 'G-3G', value: 6 },
        { label: 'D5X-HDD', value: 7 },
        { label: 'D5X-XR', value: 8 },
        { label: 'BSJ-GF06', value: 9 },
        { label: 'BSJ-RM01', value: 10 }
      ],
      positioningDeviceSourceTypeOptions: [
        { label: '新装', value: 1 },
        { label: '接入', value: 2 }
      ],
      positioningDeviceInfo: {
        id: null,
        terminalNum: null,
        factoryTerminalNum: null,
        positioningDeviceModel: null,
        sourceType: null,
        remark: null,
        setupDatetime: null,
        serviceDatetime: null
      },
      listLoadding: false,
      columns: [
        {
          title: 'ID',
          resizable: true,
          key: 'id',
          sortable: 'custom',
          tooltip: 'true',
          minWidth: 70
        },
        {
          title: '主机号',
          resizable: true,
          key: 'terminalNum',
          ellipsis: 'true',
          minWidth: 100
        },
        {
          title: '设备型号',
          resizable: true,
          key: 'positioningDeviceModel',
          ellipsis: 'true',
          minWidth: 100,
          render: function (h, params) {
            let positioningDeviceModel = params.row.positioningDeviceModel
            if (positioningDeviceModel === 1) {
              return h('div', 'BSJ-A6-BD')
            } else if (positioningDeviceModel === 2) {
              return h('div', 'BSJ-GF03')
            } else if (positioningDeviceModel === 3) {
              return h('div', 'BSJ-M11')
            } else if (positioningDeviceModel === 4) {
              return h('div', 'K5')
            } else if (positioningDeviceModel === 5) {
              return h('div', 'D5X')
            } else if (positioningDeviceModel === 6) {
              return h('div', 'G-3G')
            } else if (positioningDeviceModel === 7) {
              return h('div', 'D5X-HDD')
            } else if (positioningDeviceModel === 8) {
              return h('div', 'D5X-XR')
            } else if (positioningDeviceModel === 9) {
              return h('div', 'BSJ-GF06')
            } else if (positioningDeviceModel === 10) {
              return h('div', 'BSJ-RM01')
            } else {
              return h('div', '未知')
            }
          }
        },
        {
          title: '设备来源',
          resizable: true,
          key: 'sourceType',
          ellipsis: 'true',
          minWidth: 100,
          render: function (h, params) {
            let sourceType = params.row.sourceType
            if (sourceType === 1) {
              return h('div', '新装')
            } else if (sourceType === 2) {
              return h('div', '接入')
            }
          }
        },
        {
          title: '操作',
          resizable: true,
          key: 'action',
          align: 'left',
          ellipsis: 'true',
          minWidth: 150,
          render: (h, params) => {
            return h('div', [
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small',
                  disabled: false
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.setDatetimeId = params.row.id
                    this.exportDatetime = new Date()
                    if (params.row.setupDatetime) {
                      this.installDatetime = new Date(params.row.setupDatetime)
                    } else {
                      this.installDatetime = new Date()
                    }
                    this.setDatetimeModal = true
                  }
                }
              }, '导出证明')
            ])
          }
        }
      ]
    }
  },
  methods: {
    ...mapActions([
      'PositioningDeviceInfoServ_GetDetail',
      'PositioningDeviceInfoServ_ModifyObj',
      'VehicleInfoServ_BindPositioningDeviceInfos',
      'VehicleInfoServ_UnBindPositioningDeviceInfos',
      'PositioningDeviceInfoServ_GetAll'
    ]),
    onOk () {
      let setupDatetime = this.installDatetime.Format('yyyy-MM-dd hh:mm:ss')
      let exportDatetime = this.exportDatetime.Format('yyyy-MM-dd hh:mm:ss')
      window.location.href = '/api/im/positioningdeviceinfo/generatecertificate/' + this.setDatetimeId + '/' + this.certificateArea + '/' + setupDatetime + '/' + exportDatetime
    },
    onBindPositioningDeviceInfos () {
      this.$Modal.confirm({
        title: '确认绑定设备',
        content: '<p>确认绑定设备</p>',
        onOk: () => {
          store.dispatch('VehicleInfoServ_BindPositioningDeviceInfos', {
            params: { id: this._initValue, positioningDeviceInfoIds: this.selectPositioningDeviceInfos }
          }).then(() => {
            this.$Message.success('修改成功')
            this.updateTable()
            this.$emit('on-success')
          }).catch(err => {
            this.$Message.error(err)
            this.$emit('on-fail')
          })
        },
        onCancel: () => {

        }
      })
    },
    searchPositioningDeviceInfo (input) {
      this.searchPositioningDeviceInfoLoading = true
      if (!input || input.length <= 0) {
        this.searchPositioningDeviceInfoList = []
        this.searchPositioningDeviceInfoLoading = false
      } else {
        store.dispatch('PositioningDeviceInfoServ_SearchByName', {
          params: { name: input },
          urlparams: null
        }).then(() => {
          this.searchPositioningDeviceInfoList = store.getters.get_PositioningDeviceInfo_SearchByNameResult ? store.getters.get_PositioningDeviceInfo_SearchByNameResult : []
          this.searchPositioningDeviceInfoLoading = false
        }).catch(err => {
          this.searchPositioningDeviceInfoLoading = false
        })
      }
    },
    sortChange ({ column, key, order }) {
      this.sort = {
        name: key,
        asc: order === 'asc'
      }
      this.refreshPage()
    },
    updateTable () {
      this.listLoadding = true
      let queryParams = []
      let sortParam = null
      queryParams.push(genQueryParam('vehicleInfoId', 'EQ', this._initValue))
      store.dispatch('PositioningDeviceInfoServ_GetAll', {
        params: null,
        urlparams: {
          q: queryParams,
          keyword: null,
          sort: sortParam
        }
      }).then(() => {
        this.listLoadding = false
      }).catch(err => {
        this.listLoadding = false
        this.$Message.error(err)
      })
    },
    visibleChange (val) {
      if (val) {
        this.searchPositioningDeviceInfoList = []
        this.selectPositioningDeviceInfos = []
        this.listLoadding = true
        let queryParams = []
        let sortParam = null
        if (this.installed) {
          queryParams.push(genQueryParam('vehicleInfoId', 'EQ', this._initValue))
        } else {
          queryParams.push(genQueryParam('installOrderId', 'EQ', this._initValue))
        }
        store.dispatch('PositioningDeviceInfoServ_GetAll', {
          params: null,
          urlparams: {
            q: queryParams,
            keyword: null,
            sort: sortParam
          }
        }).then(() => {
          this.listLoadding = false
        }).catch(err => {
          this.listLoadding = false
          this.$Message.error(err)
        })
      }
    }
  },
  computed: {
    content () {
      if (store.getters.get_PositioningDeviceInfo_GetAllResult) {
        return store.getters.get_PositioningDeviceInfo_GetAllResult
      } else {
        return []
      }
    },
    _value: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
        this.$emit('change', val)
      }
    },
    _installed: {
      get () {
        return this.installed
      },
      set (val) {
        // this.$emit('input', val)
        // this.$emit('change', val)
      }
    },
    _initValue: {
      get () {
        return this.initValue
      },
      set (val) {
        // this.$emit('input', val);
        // this.$emit('change', val);
      }
    }
  },
  mounted () {
    this.$nextTick(() => {

    })
  }
}
</script>
